import { loadMe } from './me';

/**
 * Confirms the signed-in Entra identity resolves to a real, active user by
 * calling core's `GET /me` through the gateway. MSAL's `isAuthenticated`
 * alone only proves the Entra sign-in succeeded — it says nothing about
 * whether that identity exists (or is active) in this app, so the router
 * gates the home route on this call before rendering anything beyond login.
 *
 * Goes through loadMe, so the store's init reuses this same response instead of
 * asking again. Only whether the session resolved
 * matters here; an empty 200 still counts (fetchMe tolerates it).
 */
export async function verifySession(
  getAccessToken: (forceRefresh?: boolean) => Promise<string>
): Promise<boolean> {
  return (await loadMe(getAccessToken)) !== null;
}
